const getThemeBackground = theme => {
  switch (theme) {
    case 'Pharma':
    case 'Default-Theme':
      return '#f3f3f3'
    case 'Beauty':
      return '#f2f2f2'
    case 'Darknight':
      return '#121212'
    default:
      return '#fff'
  }
}

export default getThemeBackground
